var React = require('react');

function PersonIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"person-icon"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"person-icon","fill":"#F37D5A","fillRule":"nonzero"},[React.createElement("circle",{"id":"Oval","cx":"10.5","cy":"5.5","r":"5.5","key":0}),React.createElement("path",{"d":"M10,12 C15.5228475,12 20,16.4771525 20,22 L20,31 L0,31 L0,22 C0,16.4771525 4.4771525,12 10,12 Z","id":"Path","key":1})]))]);
}

PersonIcon.defaultProps = {"width":"20px","height":"31px","viewBox":"0 0 20 31","version":"1.1"};

module.exports = PersonIcon;

PersonIcon.default = PersonIcon;
